import type { ReactNode } from 'react';
import { DataTableFooterShell } from './FooterShell';

export interface DataTableLoadedCountProps {
    /** Rows accumulated so far - `rows.length`, not a page size. */
    loaded: number;
    /** Omit when the endpoint doesn't report a total; renders just `loaded`. */
    total?: number;
    trailing?: ReactNode;
    className?: string;
}

/**
 * `'infinite'` mode's footer content: there is no "page N of M" while chunks
 * keep accumulating, so a loaded-vs-total count is the useful substitute.
 */
export function DataTableLoadedCount({
    loaded,
    total,
    trailing,
    className
}: DataTableLoadedCountProps) {
    return (
        <DataTableFooterShell trailing={trailing} className={className}>
            <span className="text-sm text-gray-500">
                {total === undefined ? `${loaded} loaded` : `${loaded} of ${total} loaded`}
            </span>
        </DataTableFooterShell>
    );
}
